export default class CacheBuster {
	public static Bust(url: string): string {
		return url + "?bust=" + Date.now().toString();
	}
}
